import { encodeQr, qrPath, type QrErrorLevel } from '@wms/domain';
import { useMemo } from 'react';

/** A QR code with its quiet zone, crisp at any size (the authenticator link of two-factor setup). */
export function QrCode({ text, size = 220, level = 'M', label = 'QR kod' }: { text: string; size?: number; level?: QrErrorLevel; label?: string }) {
  const code = useMemo(() => encodeQr(text, level), [text, level]);
  const side = code.size + 8;
  return (
    <svg viewBox={`0 0 ${side} ${side}`} width={size} height={size} role="img" aria-label={label} style={{ display: 'block', borderRadius: 8 }}>
      <rect width={side} height={side} fill="#fff" />
      <path d={qrPath(code, 4)} fill="#000" shapeRendering="crispEdges" />
    </svg>
  );
}
